import client from './client'

const fetchHverfi = () => {
  return client.get('/items/hverfi', {
    fields: [
      'key',
      'title',
      'body',
      'body_full',
      'body_full_dev',
      'body_gogn',
      'gogn.item.*',
      'image.data',
      'image.width',
      'image.height',
      'meta',
      'tegund',
      'lodir.*.*',
      'deiliskipulag.*',
      'afangar.title',
      'afangar.slug',
      'afangar.status',
      'afangar.deiliskipulag.body',
    ],
  })
}

export default fetchHverfi
